import { Component, OnInit } from "@angular/core";
import { Input } from "@angular/core";
import { Output } from "@angular/core";
import { EventEmitter } from "@angular/core";

@Component({
    selector: "dodo-button",
    templateUrl: "./button.component.html",
    styleUrls: ["./button.component.scss"],
    standalone: false
})
export class ButtonComponent implements OnInit {
	@Input() settings = null;
	// @Output() buttonClicked: EventEmitter<any> = new EventEmitter();
	@Input() text = "";
	@Input() busy = false;
	@Input() width: string;
	@Input() height: string;
	@Input() mgr: string;
	@Input() color = "primary";
	@Input() disabled = false;
	@Output() clicked = new EventEmitter();

	active: Boolean = false;

	constructor() {}

	ngOnInit() {
		if (this.settings && this.settings.active) {
			this.active = this.settings.active || this.active;
		}
	}

	public buttonClicked(event: Event): void {
		event.stopPropagation();
		if (this.settings === null) {
			this.clicked.emit(event);
		} else {
			this.clicked.emit(this.settings); // for old code
		}

		// for old code
		// this.buttonClicked.emit(this.settings);
		this.active = !this.active;

		if (this.settings && this.settings.clickAction) {
			this.settings.clickAction();
		}
	}

	// onButtonClick($event?) {
	// 	this.clicked.emit(this.settings);
	// 	this.active = !this.active;

	// 	if (this.settings && this.settings.clickAction) {
	// 		this.settings.clickAction();
	// 	}
	// }
}
